/**
 * H est-elle ouverte ? Une seule autorité, et un frein.
 *
 * DEUX DRAPEAUX AUX DÉFAUTS OPPOSÉS. `ARCHITECTURE_H` (serveur) valait
 * « fermé » par défaut ; `REACT_APP_FICHE_H` (bundle) valait « ouvert » par
 * défaut. L'état livré était donc : l'accueil invite à « essayer le nouveau
 * parcours », l'utilisateur clique, et la page échoue — avec, par-dessus le
 * message « ce parcours n'est pas encore ouvert », un second message qui dit
 * « La fiche n'a pas pu être créée. Réessayez dans un instant. » Deux
 * affirmations contradictoires sur le même écran, dont une fausse et qui
 * invite à réessayer indéfiniment.
 *
 * LA RÈGLE, MAINTENANT. Le SERVEUR décide : lui seul sait si les routes
 * répondent. Le bundle ne peut que FERMER — jamais ouvrir. C'est ce qui rend
 * le retour en arrière sûr dans les deux sens :
 *
 *   - urgence côté client  : `REACT_APP_FICHE_H=0`, la porte disparaît de
 *     l'accueil sans toucher au serveur ;
 *   - urgence côté serveur : `ARCHITECTURE_H=0`, les routes rendent 404 et
 *     l'accueil cesse d'y conduire au prochain chargement, sans redéploiement
 *     du bundle.
 *
 * Et un service INJOIGNABLE n'est pas un service ouvert : on ne pousse
 * personne vers un parcours dont on ne sait rien.
 */
import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/v1/fiches`;

/** Le frein du bundle. Il ne peut que fermer. */
export const FERMEE_PAR_LE_BUNDLE = process.env.REACT_APP_FICHE_H === "0";

/**
 * L'état d'ouverture, décidé à partir de ce que l'on sait.
 *
 * « inconnue » : on n'a pas encore demandé.
 * « indisponible » : on a demandé, on n'a pas pu savoir.
 */
export function decisionDOuverture({ fermeeParLeBundle, reponse, echec }) {
  if (fermeeParLeBundle) return "fermee";
  if (echec) return "indisponible";
  if (reponse === undefined || reponse === null) return "inconnue";
  return reponse.ouverte === true ? "ouverte" : "fermee";
}

/** Conduit-on l'utilisateur vers H ? Seul « ouverte » vaut oui. */
export function porteOuverte(etat) {
  return etat === "ouverte";
}

/**
 * Demande au serveur, une fois, et retient la réponse pour l'onglet.
 *
 * Sans ce cache, chaque composant qui s'interroge sur la porte ajouterait une
 * requête à chaque rendu de l'accueil.
 */
let _cache = null;

export function oublierLOuverture() {   // pour les tests
  _cache = null;
}

export function useOuvertureH() {
  const [etat, setEtat] = useState(() =>
    FERMEE_PAR_LE_BUNDLE
      ? "fermee"
      : decisionDOuverture({ fermeeParLeBundle: false, reponse: _cache })
  );

  useEffect(() => {
    if (FERMEE_PAR_LE_BUNDLE || _cache) return undefined;
    let vivant = true;
    axios.get(`${API}/objectifs`)
      .then(({ data }) => {
        _cache = data;
        if (vivant) setEtat(decisionDOuverture({ fermeeParLeBundle: false, reponse: data }));
      })
      .catch(() => {
        if (vivant) setEtat("indisponible");
      });
    return () => { vivant = false; };
  }, []);

  return etat;
}
